<template>
  <div>
    <div class="row" style="padding-top:5em">
      <br>
    </div>
    <div class="card">
  <h4 class="text-center" style="padding-top: 4em">Error 403</h4>
  <div class="lock"></div>
  <div class="message">
    <h1 class="text-center display-4">Acceso denegado</h1>
    <p class="text-center">Favor comunicarse con un administrador del sistema para solicitar el permiso.</p>
    <br>
    <div class="text-center" style="padding-bottom: 4em">
      <b-button pill  to="/" variant="info" class="pr-2 pl-2"> Ir a Inicio 🏠 </b-button>
    </div>
    <br>
  </div>
  </div>
  </div>
</template>
<script>
export default {
  name: "page-forbidden"
};
</script>
<style scoped>@import url("https://fonts.googleapis.com/css?family=Lato");
* {
  position: relative;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Lato", sans-serif;
}

body {
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: linear-gradient(to bottom right, #EEE, #AAA);
}

h1 {
  margin: 10px 0 20px;
}

.lock {
  border-radius: 5px;
  width: 55px;
  height: 33px;
  background-color: #333;
  animation: dip 1s;
  animation-delay: 1.5s;
  margin: 40px auto;
}
.lock::before, .lock::after {
  content: "";
  position: absolute;
  border-left: 5px solid #333;
  height: 20px;
  width: 25px;
  left: calc(50% - 12.5px);
}
.lock::before {
  top: -25px;
  border: 5px solid #333;
  border-bottom-color: transparent;
  border-radius: 15px 15px 0 0;
  height: 35px;
  animation: lock 2s, spin 2s;
}
.lock::after {
  top: -10px;
  border-right: 5px solid transparent;
  animation: spin 2s;
}

@keyframes lock {
  0% {
    top: -42px;
  }
  65% {
    top: -42px;
  }
  100% {
    top: -25px;
  }
}
@keyframes spin {
  0% {
    transform: scaleX(-1);
    left: calc(50% - 30px);
  }
  65% {
    transform: scaleX(1);
    left: calc(50% - 12.5px);
  }
}
@keyframes dip {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(10px);
  }
  100% {
    transform: translateY(0px);
  }
}

</style>
